export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10274.91008e2b.jpg";